module.exports = __webpack_public_path__ + "img/home2.1ef1dab4.png";